// extracted by mini-css-extract-plugin
export default {"card":"ServicesCard_card__UyOXX"};